import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';

import { NewTimeSelectorComponent } from 'src/app/components/new-time-selector/new-time-selector.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { NgbPopoverModule, NgbTimepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { MomentFormatPipe } from 'src/app/pipes/moment-format.pipe';
import { PassengerNameFormatPipe } from 'src/app/pipes/passenger-name-format.pipe';
import { TaskDetailsOooiPipe } from 'src/app/pipes/task-details-oooi.pipe';
import { LoadingScreenComponent } from 'src/app/components/loading-screen/loading-screen.component';
import { IsoToNgbDatePipe } from 'src/app/pipes/iso-to-ngb-date.pipe';

@NgModule({
  declarations: [
    NewTimeSelectorComponent,
    MomentFormatPipe,
    PassengerNameFormatPipe,
    TaskDetailsOooiPipe,
    IsoToNgbDatePipe,
    LoadingScreenComponent
  ],
  imports: [
    CommonModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatButtonModule,
    MatInputModule,
    NgxMaterialTimepickerModule,
    FormsModule,
    ReactiveFormsModule,
    NgbTimepickerModule,
    MatSlideToggleModule,
    MatSelectModule,
    NgbPopoverModule,
    MatOptionModule,
    MatIconModule
  ],
  providers: [ DatePipe ],
  exports: [
    NewTimeSelectorComponent,
    MomentFormatPipe,
    PassengerNameFormatPipe,
    TaskDetailsOooiPipe,
    LoadingScreenComponent,
    IsoToNgbDatePipe
  ]
})
export class SharedModule {}
